import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface PrimaryButtonProps {
  icon?: string;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  size?: ButtonSize;
}

type ButtonSize = 'small' | 'medium' | 'large';

const PrimaryButton: FunctionComponent<PrimaryButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'primary',
  };

  return <BaseButton {...baseProps} />;
};

export default PrimaryButton;
